import { PageHeader } from "@/components/PageHeader";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { Manifesto } from "@/components/sections/Manifesto";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/motion/Reveal";
import { CtaBanner } from "@/components/sections/CtaBanner";
import { FaqSection } from "@/components/sections/FaqSection";
import { IMAGES } from "@/data/content";
import { CheckCircle2 } from "lucide-react";

const points = [
  "Press the waterproof button — or let fall detection do it for you.",
  "A US-based operator answers in seconds and sees your exact location.",
  "They talk you through it and dispatch family or 911 as needed.",
  "The operator stays on the line until help physically arrives.",
];

export default function HowItWorksPage() {
  return (
    <div data-testid="how-it-works-page">
      <PageHeader
        eyebrow="How It Works"
        title={<>One press. <span className="text-brand-red">Help on the way.</span></>}
        sub="From the moment you press the button to the moment help arrives, you're never handling an emergency alone."
      />

      <HowItWorks />

      <section className="py-20 lg:py-28 bg-brand-bg">
        <div className="container-x grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <img
              src={IMAGES.operator}
              alt="US-based monitoring specialist wearing a headset"
              className="rounded-[2rem] shadow-cardHover w-full h-[460px] object-cover ring-1 ring-brand-line"
            />
          </Reveal>
          <div>
            <SectionHeading
              eyebrow="When You Press The Button"
              title={<>A real human, <span className="text-brand-red">in seconds.</span></>}
              sub="No menus. No robots. No offshore call centers. Just a calm, trained specialist right here in the US."
            />
            <ul className="mt-8 space-y-4">
              {points.map((p, i) => (
                <Reveal key={i} delay={i * 0.08}>
                  <li className="flex items-start gap-3.5 text-lg text-brand-navy">
                    <CheckCircle2 className="w-7 h-7 shrink-0 text-brand-red mt-0.5" strokeWidth={2} />
                    <span>{p}</span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <Manifesto />
      <FaqSection limit={5} />
      <CtaBanner />
    </div>
  );
}
